import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ResetPasswordComponent } from "./resetPassword.component";
import { NewPasswordModule } from "app/account/asset/newPassword/newPassword-form.module";

@NgModule({
    declarations: [
      ResetPasswordComponent
    ],
    imports: [
      CommonModule,
      NewPasswordModule
    ],
    providers: [
    ]
})
export class ResetPasswordModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/account/resetPassword/resetPassword.module.ts